/**
 * @generated SignedSource<<f4d93b25009daac1242b6db8619fec15>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disabledDate",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AssignmentTypeStatusUpdateModal_updateAssignmentTypeMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateAssignmentTypePayload",
                    "kind": "LinkedField",
                    "name": "updateAssignmentType",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfAssignmentType",
                            "kind": "LinkedField",
                            "name": "assignmentTypeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AssignmentTypeStatusUpdateModal_updateAssignmentTypeMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateAssignmentTypePayload",
                    "kind": "LinkedField",
                    "name": "updateAssignmentType",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfAssignmentType",
                            "kind": "LinkedField",
                            "name": "assignmentTypeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentType",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "cb8b6e511a6225f0f34944a0423bc996",
            "id": null,
            "metadata": {},
            "name": "AssignmentTypeStatusUpdateModal_updateAssignmentTypeMutation",
            "operationKind": "mutation",
            "text": "mutation AssignmentTypeStatusUpdateModal_updateAssignmentTypeMutation(\n  $model: UpdateAssignmentTypeRequestInput!\n) {\n  updateAssignmentType(model: $model) {\n    assignmentTypeEdge {\n      node {\n        disabledDate\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "677e207940eb73fc307a476094160c0e";
export default node;
